import { useMemo, useState } from 'react';
import isArrayNotEmpty from 'utils/isArrayNotEmpty';
import { resetLocationsOrder } from '../../utils/booking/resetLocationsOrder';

/**
 * Hook to separate logic for locations API
 * @param {Array} allLocations List of all locations
 * @param sortingAlgorithm
 * @returns
 */
export function useLocations(allLocations, sortingAlgorithm) {
  const memoizedLocations = useMemo(() => {
    if (!isArrayNotEmpty(allLocations)) return [];
    return resetLocationsOrder(allLocations, sortingAlgorithm);
  }, [allLocations]);

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [closestLocations, setClosestLocations] = useState(memoizedLocations);

  const resetSelectedLocation = () => setSelectedLocation(null);

  return {
    memoizedLocations,
    selectedLocation,
    setSelectedLocation,
    resetSelectedLocation,
    closestLocations,
    setClosestLocations,
  };
}
